export default __webpack_public_path__ + "static/media/image-tanya.f54c0657.jpg";